export default "<div id=\"icon-menubar\">\n  <i class=\"fa fa-subject icon-menu\" theme (click)=\"toggleMenu()\"></i>\n</div>\n";